<div class="tableContainer">
    <div class="tableHeadline">
        <h3 class="form-headline">{{title}} </h3>
        <ul *ngIf="showCount">
            <li class="tableHeadline__metaData"><span>{{getTotalElement()}} {{i18n.totalElementText}}</span></li>
        </ul>
    </div>
    <div class="controlWrapper" *ngIf="!disableTopPagination && (page || showIcons)" #pageControlViewDuplicate>
        <common-table-pagination *ngIf="page" (pageChange)="onChangePage($event)" [page]="page" [showPageSize]="showPageSize">
        </common-table-pagination>
        <div class="tableControl">
            <ng-container *ngTemplateOutlet="ngContent"></ng-container>
        </div>
    </div>
    <div class="table-wrapper">
        <div class="scrollable" [ngClass]="{'overflow-y-hidden-ie11fix': rows?.length === 0, 'forceScrollbar': forceScrollbar}">
            <table class="spp-table">
                <thead>
                    <tr *ngIf="!disableColumnTitle" class="tr noHover mainHeader">
                        <th *ngIf="multiRowSelection" class="th control">
                            <common-form-input
                                    class="table-head-checkbox"
                                    type="checkbox"
                                    [(ngModel)]="multiRowSelectionAllSelected"
                                    (isChecked)="onMultiRowSelectionSelectAll($event)"
                                    ngDefaultControl></common-form-input>
                        </th>
                        <th *ngFor="let column of columns" [class]="'th ref ' + (column.cssClassHead ? column.cssClassHead : '')">
                            {{column.title}}
                        </th>
                    </tr>
                    <tr class="tr noHover tableFilter" *ngIf="isFilter">
                        <th *ngIf="multiRowSelection" class="th control"><span></span></th>
                        <th *ngFor="let column of columns" class="th" [ngClass]="{'columnDate':column.date,'columnIcon':column.icon}">
                            <div *ngIf="column.property" class="search">
                                <ng-container
                                    [ngTemplateOutlet]="columnFilterTemplateByName[column.name] || defaultFiltersTemplate"
                                    [ngTemplateOutletContext]="{$implicit : filterControls[column.property]}">
                                </ng-container>
                                <ng-template #defaultFiltersTemplate let-fc>
                                    <common-table-text-filter *ngIf="!column.date && !column.multiSelection"
                                        [formControl]="fc">
                                    </common-table-text-filter>
                                    <common-table-multi-select-filter *ngIf="column.multiSelection"
                                        [formControl]="fc"
                                        [items]="multiSelectItemMap[column.property]"
                                        [single]="column.restrictedMultiSelection">
                                    </common-table-multi-select-filter>
                                    <common-table-date-range-filter *ngIf="column.date"
                                        [formControl]="fc">
                                    </common-table-date-range-filter>
                                </ng-template>

                            </div>
                        </th>
                    </tr>
                    <tr class="tr noHover tableSorting" *ngIf="isSort">
                        <th *ngIf="multiRowSelection" class="th control"><span></span></th>
                        <th *ngFor="let column of columns" class="th tableSortingCol">
                  <span (sortChanged)="onChangeSort($event)" sortTable
                        [column]="column" class="tableSortingAction" *ngIf="column.sort"
                        [ngClass]="{
                          'icon-upwards': column.sort === 'desc',
                          'icon-downwards': column.sort === 'asc',
                          'icon-sort inactive': column.sort === 'inactive'
                        }"></span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let row of rows, let index = index">
                        <ng-container *ngTemplateOutlet="dataRowDirective?.template || dataRowTemplate; context:{row, index, columnsTemplate: allColumnsTemplate}"></ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf="rows?.length === 0"><span>{{noDataMsg}}</span></div>
    <div class="controlWrapper controlWrapper--disableTopPadding" *ngIf="!disableBottomPagination && (page || showIcons)" #pageControlViewDuplicate>
        <common-table-pagination *ngIf="page" (pageChange)="onChangePage($event)" [page]="page" [showPageSize]="showPageSize"
        ></common-table-pagination>
        <div class="tableControl" *ngIf="disableTopPagination">
            <ng-container *ngTemplateOutlet="ngContent"></ng-container>
        </div>
    </div>
</div>

<ng-template #dataRowTemplate let-row="row" let-index="index" let-columnsTemplate="columnsTemplate">
    <tr class="tr" [ngClass]="{'noHover': !showHover}">
        <ng-container *ngTemplateOutlet="columnsTemplate; context:{row, index}"></ng-container>
    </tr>
</ng-template>

<ng-template #allColumnsTemplate let-row="row" let-index="index">
    <td *ngIf="multiRowSelection" class="td" ngDefaultControl>
        <common-form-input type="checkbox"
                           [(ngModel)]="row.checked"
                           (isChecked)="onMultiRowSelectionSelectContent(row)"
                           ngDefaultControl></common-form-input>
    </td>
    <td *ngFor="let column of columns" (click)="onRowClick(row)" class="td">
        <ng-container *ngIf="isTemplateColumn">
            <ng-container [ngTemplateOutlet]="columnTemplate"
                 [ngTemplateOutletContext]="{ column: column, row: row, index: index }">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!isTemplateColumn">
            <ng-container [ngTemplateOutlet]="columnCellTemplateByName[column.name] || defaultCellTemplate"
                 [ngTemplateOutletContext]="{ $implicit: row, index: index }">
            </ng-container>
            <ng-template #defaultCellTemplate>{{row[column.name]}}</ng-template>
        </ng-container>
    </td>
</ng-template>

<ng-template #ngContent>
    <ng-content></ng-content>
</ng-template>
